import { useState } from "react";
import { useSelector } from "react-redux";
import { requestFeature } from "pro-features/components/Modals/src/HookModal/services/requestFeature";
import { SI_CONTACTS_HOOK_ID } from "app/pages/sales-intelligence/constants/common";
import type { UseAccessRequestPropsType } from "./type";
import { selectIsContactsVisible } from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/selectors";

export const useAccessRequestProps = (): UseAccessRequestPropsType => {
    const [accessRequested, setAccessRequested] = useState(false);
    const hasAccess = useSelector(selectIsContactsVisible);

    const requestAccess = () => {
        setAccessRequested(true);
        requestFeature(SI_CONTACTS_HOOK_ID);
    };

    return { hasAccess, accessRequested, requestAccess };
};
